export default __webpack_public_path__ + "static/media/195-united arab emirates.9f5f0beb.svg";